<template>
  <!-- Header -->
  <header class="bg-white dark:bg-gray-800 p-2 border-b-2 dark:border-gray-700">
    <div class="wrap-header flex items-center gap-5 justify-between flex-wrap">
      <div class="flex flex-no-shrink items-center">
        <button
          class="text-gray-500 lg:hidden ml-3 block"
          @click="$emit('sidebarToggle', true)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            width="2em"
            height="2em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 16 16"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M2.75 12.25h10.5m-10.5-4h10.5m-10.5-4h10.5"
            />
          </svg>
        </button>

        <!-- Search box (static حالياً) -->
        <div
          class="input-box border dark:bg-gray-900 lg:ml-0 ml-5 dark:border-gray-700 rounded-md hidden lg:w-search w-full box-border lg:flex md:flex focus-within:bg-gray-100 dark:focus-within:bg-gray-700"
        >
          <span class="text-3xl p-2 text-gray-400">
            <Icon icon="ei:search" />
          </span>
          <input
            type="text"
            placeholder="Search..."
            class="p-3 w-full bg-white dark:bg-gray-900 dark:text-gray-400 rounded-md outline-none focus:bg-gray-100 dark:focus:bg-gray-700"
          />
        </div>
      </div>

      <div class="mr-5 flex gap-3">
        <!-- Search icon for mobile -->
        <button class="lg:hidden block mr-5 text-2xl text-gray-500 relative">
          <i>
            <Icon icon="ic:outline-search" />
          </i>
        </button>

        <!-- Fullscreen -->
        <button
          @click="fullscreenToggle"
          class="mr-5 text-2xl text-gray-500 relative"
        >
          <i v-if="!fullscreenMode">
            <Icon icon="ic:outline-fullscreen" />
          </i>
          <i v-else>
            <Icon icon="ic:outline-fullscreen-exit" />
          </i>
        </button>

        <!-- Dark / Light toggle -->
        <button
          @click="setTheme(true)"
          class="mr-5 text-2xl text-gray-500"
          v-if="!darkMode"
        >
          <Icon icon="ph:sun-dim" />
        </button>
        <button
          @click="setTheme(false)"
          v-else
          class="mr-5 text-2xl text-gray-500"
        >
          <Icon icon="ri:moon-fill" />
        </button>

        <!-- Notifications button -->
        <button
          @click="notifToggle"
          class="mr-5 text-2xl text-gray-500 relative"
        >
          <!-- نقطة حمراء لو في إشعارات غير مقروءة -->
          <span
            v-if="unreadCount > 0"
            class="bg-red-500 rounded-full w-3 h-3 border border-white dark:border-gray-700 -mt-1 absolute -right-1 top-0"
          ></span>
          <Icon icon="clarity:notification-line" />
        </button>

        <!-- Notifications dropdown -->
        <transition name="fade">
          <div
            id="notificaitons"
            v-show="notification"
            class="block absolute lg:right-56 right-28 mt-12 z-50 w-96 border dark:border-gray-700 bg-white dark:bg-gray-800 rounded divide-y dark:divide-gray-700 divide-gray-100 shadow"
          >
            <!-- Header -->
            <div
              class="flex justify-between p-3 text-gray-800 dark:text-gray-300"
            >
              <!-- <h2>Notifications</h2> -->
              <button
                class="text-blue-500 text-sm"
                @click="markAllAsRead"
                :disabled="!notifList.length"
              >
                Mark all as Read
              </button>
            </div>

            <!-- No notifications -->
            <!-- <div class="p-5 text-center" v-if="!notifList.length">
              <p class="text-gray-800 dark:text-gray-300">
                No notifications yet.
              </p>
            </div> -->

            <!-- Notifications list -->
            <!-- <div
              class="p-2 pl-3 w-full"
              v-for="(item, index) in notifList"
              :key="item.notification_id || index"
            >
              <div class="flex gap-3">
                <div
                  class="w-9 h-9 rounded-full flex items-center justify-center bg-blue-100 dark:bg-blue-900"
                >
                  <Icon
                    icon="clarity:notification-outline-badged"
                    class="text-blue-600 dark:text-blue-300 text-xl"
                  />
                </div>
                <div class="mt-1 flex-1">
                  <div class="flex flex-col">
                    <h2 class="dark:text-gray-200 font-semibold text-sm">
                      {{ item.title }}
                    </h2>
                    <p
                      class="dark:text-gray-400 text-gray-500 text-xs mt-1"
                    >
                      {{ limitText(item.message) }}
                    </p>
                  </div>
                  <p
                    class="text-[11px] dark:text-gray-500 text-gray-400 mt-1"
                  >
                    {{ formatDate(item.created_at) }}
                    <span
                      v-if="item.is_read === false"
                      class="ml-2 inline-block px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-[10px]"
                    >
                      New
                    </span>
                  </p>
                </div>
              </div>
            </div> -->

            <div class="p-2">
              <button class="w-full p-2 text-gray-800 dark:text-gray-300">
                View All
              </button>
            </div>
          </div>
        </transition>

        <!-- User menu -->
        <button
          @blur="menuToggleBlur"
          @click="menuToggle"
        >
          <div class="user-avatar flex p-1 cursor-pointer rounded-md">
            <div>
              <img
                src="../assets/img/user.jpg"
                class="rounded-full mr-4 w-10 h-10 p-1 ring-1 ring-gray-300 dark:ring-gray-500"
                alt=""
              />
            </div>
            <div class="text-left lg:block md:block hidden">
              <h2 class="dark:text-white text-gray-800">Hi, Rofaida</h2>
              <p class="text-xs text-gray-400 dark:text-gray-500">
                Frontend Developer
              </p>
            </div>
          </div>
        </button>

        <!-- Dropdown user -->
        <transition name="fade">
          <div
            id="dropdownSmall"
            v-show="menu"
            class="block absolute right-10 mt-12 z-50 w-52 border dark:border-gray-700 bg-white dark:bg-gray-800 rounded divide-y dark:divide-gray-700 divide-gray-100 shadow"
          >
            <div class="py-3 px-4 text-sm text-gray-900 dark:text-gray-200">
              <div>Logged As</div>
              <div class="font-medium truncate">Rofaida</div>
            </div>
            <ul
              class="py-1 text-sm text-gray-700 dark:text-gray-200"
              aria-labelledby="dropdownSmallButton"
            >
              <li>
                <a
                  href="#"
                  class="block py-2 px-4 hover:bg-primary hover:text-white"
                  >User Profile</a
                >
              </li>
              <li>
                <a
                  href="#"
                  class="block py-2 px-4 hover:bg-primary hover:text-white"
                  >Settings</a
                >
              </li>

              <li>
                <a
                  href="https://github.com/sahrullahh"
                  class="block py-2 px-4 hover:bg-primary hover:text-white"
                  >Github</a
                >
              </li>
            </ul>

            <div class="py-1">
              <a
                href="#"
                class="block py-2 px-4 text-sm text-gray-700 dark:text-gray-200 hover:bg-primary hover:text-white"
                >Sign out</a
              >
            </div>
          </div>
        </transition>
      </div>
    </div>
  </header>
</template>

<script>
import { Icon } from "@iconify/vue";
import apiClient from "@/apiClient";
import { fullscreen } from "@/helper/fullscreen";
import { setDarkMode, loadDarkMode } from "@/helper/theme";

export default {
  components: {
    Icon,
  },
  data() {
    return {
      menu: false,
      darkMode: false,
      notification: false,
      fullscreenMode: false,

      // هتبقى جاية من الـ API بدل الداتا الثابتة
      notifList: [],
    };
  },
  computed: {
    // عدد الإشعارات غير المقروءة (is_read = false)
    unreadCount() {
      return this.notifList.filter((n) => n.is_read === false).length;
    },
  },
  watch: {
    $route() {
      this.menu = false;
      this.notification = false;
    },
  },
  methods: {
    fullscreen,
    setDarkMode,
    loadDarkMode,

    menuToggle() {
      this.menu = !this.menu;
    },
    menuToggleBlur() {
      this.menu = false;
    },

    notifToggle() {
      this.notification = !this.notification;
    },

    limitText(message) {
      if (!message) return "";
      return message.length > 70 ? message.substring(0, 70) + "..." : message;
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const d = new Date(dateString);
      // تاريخ + وقت مختصر
      return d.toLocaleString();
    },

    fullscreenToggle() {
      this.fullscreenMode = !this.fullscreenMode;
      this.fullscreen(this.fullscreenMode);
    },

    // تغيير الثيم
    setTheme(bool) {
      this.darkMode = bool;
      this.setDarkMode(bool);
    },

    // جلب الإشعارات من الـ API
    // async fetchNotifications() {
    //   try {
    //     const res = await apiClient.get("/notifications");

    //     // بناءً على الـ response:
    //     // { message: "Notification created successfully", data: { ... } } أو { data: [ ... ] }
    //     const payload = res.data?.data ?? res.data;

    //     if (Array.isArray(payload)) {
    //       this.notifList = payload;
    //     } else if (payload && typeof payload === "object") {
    //       this.notifList = [payload];
    //     } else {
    //       this.notifList = [];
    //     }
    //     console.log("Notifications:", this.notifList);
    //   } catch (error) {
    //     console.error("Error fetching notifications:", error);
    //     this.notifList = [];
    //   }
    // },

    // (اختياري) تعليم كل الإشعارات كمقروءة في الواجهة فقط
    // لو عندك endpoint لتحديث is_read ممكن تعملي request هنا
    async markAllAsRead() {
      // حالياً هنحدّث في الـ UI بس
      this.notifList = this.notifList.map((n) => ({
        ...n,
        is_read: true,
      }));

      // مثال لو حبيتي تربطيه بالـ API بعدين:
      // await apiClient.post('/notifications/mark-all-read')
    },
  },
  mounted() {
    // تحميل الثيم (دارك / لايت)
    this.darkMode = this.loadDarkMode();

    // جلب الإشعارات من الـ API أول ما الهيدر يركب
    // this.fetchNotifications();

    document.onfullscreenchange = () => {
      if (document.fullscreenElement) {
        this.fullscreenMode = true;
      } else {
        this.fullscreenMode = false;
      }
    };
  },
};
</script>

<style>
/* لو عندك transition باسم fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
